type MyEquipmentDrawerLinkImageProps = {
  src: string;
  alt: string;
  classname?: string;
};

export const MyEquipmentDrawerLinkImage = ({
  src,
  alt,
  classname
}: MyEquipmentDrawerLinkImageProps) => {
  return <img src={src} alt={alt} className={classname} />;
};
